import NiceModal from '@ebay/nice-modal-react'

import DeleteModal from 'components/DeleteModal'
import ConfirmModal from 'components/ConfirmModal'
import LightboxModal from 'components/LightboxModal'

import AssignmentViewLinesModal from 'components/assignment/ViewLinesModal'
import AssignmentSettingsModal from 'components/assignment/SettingsModal'
import AssignmentMapModal from 'components/assignment/MapModal'
import TripModal from 'components/modals/TripModal'

import RunsAddCustomerModal from 'components/runs/AddCustomerModal'
import RunsAddRunModal from 'components/runs/AddRunModal'
import RunsTimePickerModal from 'components/runs/TimePickerModal'

import VehiclesAddVehicleModal from 'components/vehicles/AddVehicleModal'
import VehiclesEditVehicleModal from 'components/vehicles/EditVehicleModal'

import BulletinsAddBulletinModal from 'components/bulletins/AddBulletinModal'
import BulletinsUpdateBulletinModal from 'components/bulletins/UpdateBulletinModal'
import BulletinsSendBulletinModal from 'components/bulletins/SendBulletinModal'

import PodsViewMapModal from 'components/pods/ViewMapModal'
import PodsViewSignatureModal from 'components/pods/ViewSignatureModal'

import RewindViewLinesModal from 'components/rewind/ViewLinesModal'

import ReturnsViewLinesModal from 'components/returns/ViewLinesModal'

import CustomersShowClusterModal from 'components/customers/ShowClusterModal'
import AssignmentAddRunModal from 'components/assignment/AddRunModal'
import ActiveSendDriverNotificationModal from 'components/active/SendDriverNotificationModal'
import DeliveryAddressModal from 'components/assignment/DeliveryAddressModal'
import DeliveryAddressSettingsModal from 'components/assignment/DeliveryAddressSettingsModal'
import AlertModal from 'components/assignment/AlertModal'
import AssignmentHiddenInvoiceModal from 'components/assignment/HiddenInvoiceModal'
import AssignmentResetInvoiceModal from 'components/assignment/ResetInvoiceModal'

NiceModal.register('deleteModal', DeleteModal)
NiceModal.register('confirmModal', ConfirmModal)
NiceModal.register('lightboxModal', LightboxModal)

NiceModal.register('assignmentViewLinesModal', AssignmentViewLinesModal)
NiceModal.register('assignmentSettingsModal', AssignmentSettingsModal)
NiceModal.register('assignmentMapModal', AssignmentMapModal)
NiceModal.register('assignmentAddRunModal', AssignmentAddRunModal)
NiceModal.register('assigmentHiddenInvoiceModal', AssignmentHiddenInvoiceModal)
NiceModal.register('tripModal', TripModal)

NiceModal.register('runsAddCustomerModal', RunsAddCustomerModal)
NiceModal.register('runsAddRunModal', RunsAddRunModal)
NiceModal.register('runsTimePickerModal', RunsTimePickerModal)

NiceModal.register('vehiclesAddVehicleModal', VehiclesAddVehicleModal)
NiceModal.register('vehiclesEditVehicleModal', VehiclesEditVehicleModal)

NiceModal.register('bulletinsAddBulletinModal', BulletinsAddBulletinModal)
NiceModal.register('bulletinsUpdateBulletinModal', BulletinsUpdateBulletinModal)
NiceModal.register('bulletinsSendBulletinModal', BulletinsSendBulletinModal)

NiceModal.register('podsViewMapModal', PodsViewMapModal)
NiceModal.register('podsViewSignatureModal', PodsViewSignatureModal)

NiceModal.register('activeSendDriverNotificationModal', ActiveSendDriverNotificationModal)

NiceModal.register('rewindViewLinesModal', RewindViewLinesModal)

NiceModal.register('returnsViewLinesModal', ReturnsViewLinesModal)

NiceModal.register('customersShowClusterModal', CustomersShowClusterModal)

NiceModal.register('deliveryAddressModal', DeliveryAddressModal)

NiceModal.register('deliveryAddressSettingsModal', DeliveryAddressSettingsModal)

NiceModal.register('alertModal', AlertModal)
NiceModal.register('assignmentResetInvoiceModal', AssignmentResetInvoiceModal)
